// avstemming-period-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'avhp.common.countOf': '{done} of {total}',
  'avhp.common.summary': '{done} of {total} processed · {passed} passed · {deviations} deviations',
  'avhp.common.conclusion': 'Conclusion',
  'avhp.common.cancel': 'Cancel',
  'avhp.common.open': 'Open',
  'avhp.common.hidePassed': 'Hide passed',
  'avhp.common.hide': 'Hide',
  'avhp.common.responsible': 'Responsible',
  'avhp.common.status': 'Status',
  'avhp.common.area': 'Area',
  'avhp.common.amount': 'Amount',
  'avhp.common.deadline': 'Deadline',
  'avhp.common.type': 'Type',
  'avhp.common.notAvailable': 'Not available',
  'avhp.common.sec.crossChecks': 'Cross-checks',
  'avhp.common.sec.analytics': 'Analytical review',
  'avhp.common.sec.tasks': 'Tasks and deviations',
  'avhp.common.sec.reporting': 'Reporting',
  'avhp.common.sec.areas': 'Reconciliation areas',
  'avhp.common.sec.checklist': 'Checklist',
  'avhp.common.sum.areasWithDeviation': 'Areas with deviations',
  'avhp.common.sum.accountsNoDocs': 'Accounts without documentation',
  'avhp.common.sum.openItems': 'Open reconciliation items',
  'avhp.common.sum.activeTasks': 'Active tasks',
  'avhp.common.sum.unexplainedAnalytics': 'Analytical deviations without explanation',
  'avhp.common.professionalChecklist': 'Professional checklist',
  'avhp.common.issues.one': '{count} issue',
  'avhp.common.issues.other': '{count} issues',
  'avhp.cp.notAssessed': 'Not assessed',
  'avhp.cp.ok': 'OK',
  'avhp.cp.remark': 'Remark',
  'avhp.cp.mustFix': 'Must be corrected',
  'avhp.ck.source': 'Source and evidence: {source}',
  'avhp.ck.critical': 'Critical',
  'avhp.ck.rationaleRequired': 'Rationale required',
  'avhp.ck.rationale': 'Rationale',
  'avhp.ck.deviationPlaceholder': 'What is the deviation, and what is being done about it?',
  'avhp.ck.waiting': ' · {count} waiting',
  'avhp.ck.blocked': ' · {count} blocked',
  'avhp.ck.controller': 'Reviewer',
  'avhp.ck.reviewerPointsDone': '{done} of {total} reviewer points processed',
  'avhp.ck.reviewerNote': 'The points are answered in the review tab in the right-hand panel, by someone other than the person who did the work.',
  'avhp.ck.reviewerLocked': 'Available after submission for review. The reviewer\'s points cannot be processed while the period is still being worked on by the preparer.',
  'avhp.cl.title': 'Conclusion and approval',
  'avhp.cl.areasDone': 'Reconciliation areas completed',
  'avhp.cl.untreatedPoints': 'Unprocessed control points',
  'avhp.cl.overallStatus': 'Overall status',
  'avhp.cl.approvedLocked': 'Approved and locked',
  'avhp.cl.ready': 'Ready for review',
  'avhp.cl.notReady': 'Not ready for review',
  'avhp.cl.openArea': 'Open area',
  'avhp.cl.conclusionHint': 'A period without a word about what was done has not been reviewed — it has only been opened.',
  'avhp.cl.remainingRisk': 'Remaining risk',
  'avhp.cl.followUpNext': 'Follow-up next period',
  'avhp.cl.performedBy': 'Performed by',
  'avhp.cl.checkedBy': 'Reviewed by',
  'avhp.cl.saveConclusion': 'Save conclusion',
  'avhp.cl.sendTitle': 'Sends the whole period for review by someone other than you.',
  'avhp.cl.sendTitleBlockedOne': 'The period can be sent for review, but {count} issue still remains.',
  'avhp.cl.sendTitleBlockedMany': 'The period can be sent for review, but {count} issues still remain.',
  'avhp.cl.sendToReview': 'Send for review',
  'avhp.cl.approvalNote': 'Approval is done by the reviewer in the review tab — not from here.',
  'avhp.cl.lastSaved': 'Last saved {date}',
  'avhp.cl.savedBy': ' by {email}',
  'avhp.cl.periodLock': 'Period lock',
  'avhp.cl.lockNote': 'Locking restricts changes in the period. Reopening requires a rationale, which remains in the activity log.',
  'avhp.cl.reopenPeriod': 'Reopen the period',
  'avhp.cl.lockPeriod': 'Lock the period',
  'avhp.sec.crossChecksNote': 'Checks that span several reconciliation areas.',
  'avhp.sec.showPassed': 'Show {count} passed',
  'avhp.sec.controlRule': 'Control rule',
  'avhp.sec.dataSources': 'Data sources',
  'avhp.sec.result': 'Result',
  'avhp.sec.deviation': 'Deviation',
  'avhp.sec.outcome': 'Outcome',
  'avhp.sec.confirm': 'Confirm',
  'avhp.sec.confirmedBy': 'Confirmed by {name}',
  'avhp.sec.completeness': 'Completeness and correct period',
  'avhp.sec.completenessNote': 'Plumme suggests which items should be assessed, but does not automatically conclude that they are wrong. For the rows shown as “not available” Plumme has no source yet — they have not been checked down to zero.',
  'avhp.sec.noBasisData': 'Data basis is missing for this comparison',
  'avhp.sec.analyticsNote': 'The figures are taken from the trial balance. Whether a deviation is material is determined by amount, materiality threshold, historical variation and known explanation together — not by the percentage alone, and not by Plumme.',
  'avhp.sec.thisPeriod': 'This period',
  'avhp.sec.comparison': 'Comparison',
  'avhp.sec.deviationKr': 'Deviation (kr)',
  'avhp.sec.deviationPct': 'Deviation (%)',
  'avhp.sec.explanation': 'Explanation',
  'avhp.sec.grossProfit': 'Gross profit / margin',
  'avhp.sec.marginNote': 'Revenue and cost of goods should be assessed together — the margin can fall even if gross profit increases in kroner.',
  'avhp.sec.notExplained': 'Not explained',
  'avhp.sec.editExplanation': 'Edit explanation',
  'avhp.sec.registerExplanation': 'Register explanation',
  'avhp.sec.explanationHint': 'Required. A comparison without a word about why is not an assessment.',
  'avhp.sec.documentationOptional': 'Documentation (optional)',
  'avhp.sec.voucherPlaceholder': 'Voucher number or note',
  'avhp.sec.actionFollowUp': 'Action / follow-up next period',
  'avhp.sec.saveExplanation': 'Save explanation',
  'avhp.sec.noResultLines': 'There are no income statement lines in the period to compare. If no income or expenses have been booked yet, there is no development to analyse.',
  'avhp.sec.tasksNote': 'A task is an action on a single reconciliation item in a subject area — not a copy of it. When the action is resolved, it is the source item that changes, and the task disappears from here by itself.',
  'avhp.sec.priority': 'Priority',
  'avhp.sec.sourceAreaItem': 'Source area / item',
  'avhp.sec.description': 'Description',
  'avhp.sec.waitingForCustomer': 'Waiting for customer',
  'avhp.sec.markResolved': 'Mark resolved',
  'avhp.sec.closedElsewhere': 'Closed where it belongs',
  'avhp.sec.resultHint': 'Required to mark the task as resolved — the text is saved on the source\'s reconciliation item.',
  'avhp.sec.resolvedBy': 'Resolved by',
  'avhp.sec.confirmResolved': 'Confirm resolved',
  'avhp.sec.noTasks': 'No open actions in the period. Tasks arise when someone writes an action on a reconciliation item in a subject area.',
  'avhp.sec.reportsNote': 'Deadlines are only shown where Plumme has a source for them. A deadline without a source would look just as authoritative as one that has. Plumme does not submit anything without approval.',
  'avhp.sec.reportObligation': 'Report / obligation',
  'avhp.sec.appliesToPeriod': 'Applies to period',
  'avhp.sec.dataBasis': 'Data basis',
  'avhp.sec.notRegistered': 'Not registered',
  'avhp.pg.modelNotLoaded': 'The read model for period controls has not been loaded.',
  'avhp.pg.overview': 'Overview',
  'avhp.pg.unexplained': '{count} unexplained',
  'avhp.pg.explained': 'Explained',
  'avhp.pg.activeCount': '{count} active',
  'avhp.pg.ready': 'Ready',
  'avhp.pg.blocked': 'Blocked',
  'avhp.pg.noOwnBalance': 'no balance of its own — status is taken from the other areas',
  'avhp.pg.title': 'Period controls',
  'avhp.pg.dataThrough': ' · Data basis up to and including {date}',
  'avhp.pg.responsible': ' · Responsible {name}',
  'avhp.pg.materialityLabel': ' · Materiality threshold ',
  'avhp.pg.notSet': 'not set',
  'avhp.pg.areaLimitsDiffer': ' (area-specific thresholds may differ)',
  'avhp.pg.dataVersionTitle': 'All statuses, sums and blockers on this page are read from the same accounts and the same reconciliations.',
  'avhp.pg.basisLine': 'Basis: the trial balance and the reconciliations as they stand now',
  'avhp.pg.areasProcessed': '{done} of {total} relevant areas have been fully processed.',
  'avhp.pg.blockersOne': '{count} issue blocks completion of the period.',
  'avhp.pg.blockersMany': '{count} issues block completion of the period.',
  'avhp.pg.noBlockers': 'Nothing blocks completion of the period.',
  'avhp.pg.preliminary': '{period} has not ended. This is a preliminary period control as of {date} — the final general ledger and integration data must be re-read after the period end.',
  'avhp.pg.overallOverview': 'Period overview',
  'avhp.pg.kpiRelevant': 'Relevant reconciliation areas',
  'avhp.pg.kpiDone': 'Fully processed',
  'avhp.pg.hintOpenItems': 'An identified issue in a reconciliation area. Not the same as a task.',
  'avhp.pg.kpiUnposted': 'Unposted documents in the inbox',
  'avhp.pg.hintUnposted': 'Includes documents that have been read but not booked — they are not counted separately. Shown as a separate task in the task list.',
  'avhp.pg.hintActiveTasks': 'A concrete activity meant to resolve a reconciliation item. A different measure from open items.',
  'avhp.pg.progress': 'Work progress: {pct} % processed',
  'avhp.pg.hideCalc': 'Hide calculation',
  'avhp.pg.showCalc': 'Show calculation',
  'avhp.pg.progressNote': 'Measures how much has been reviewed — not how much has passed. A processed point can still have deviations.',
  'avhp.pg.readyYes': 'Ready for reporting: Yes',
  'avhp.pg.readyNoOne': 'Ready for reporting: No — {count} issue remains',
  'avhp.pg.readyNoMany': 'Ready for reporting: No — {count} issues remain',
  'avhp.pg.finalStateNote': 'Calculated end state — not affected by more points being processed with deviations.',
  'avhp.pg.progressExplain': 'Work progress is the share of the control points in the professional checklist that have been processed — {done} of {total}. The system-derived points count once they have an answer; the professional ones count only once someone has taken a position on them. Processed points with deviations count towards progress, but do not make the period ready for reporting.',
  'avhp.pg.autoMasterControls': 'Automatically derived main controls',
  'avhp.pg.showPassedAuto': 'Show {count} passed automatic controls',
  'avhp.pg.areasNote': 'Status is taken from each area\'s own reconciliation — nothing is ticked off manually here. Click a row to open the area.',
  'avhp.pg.scope': 'Scope',
  'avhp.pg.materialBalance': 'Material balance/deviation',
  'avhp.pg.openItems': 'Open items',
  'avhp.pg.documentation': 'Documentation',
  'avhp.pg.lastUpdated': 'Last updated',
  'avhp.pg.openArea': 'Open {area}',
});
